export const STORIES_FETCH = 'STORIES_FETCH'
export const STORIES_SUCCESS = 'STORIES_SUCCESS'
export const STORIES_ERROR = 'STORIES_ERROR'
export const OPEN_NEW_YEAR_STORIES = 'OPEN_NEW_YEAR_STORIES'
export const CLOSE_NEW_YEAR_STORIES = 'CLOSE_NEW_YEAR_STORIES'